// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/verify.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../icons/upload.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../icons/monitor.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../icons/plotter.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../icons/debug-dark.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#theia-bottom-content-panel
    .p-TabBar[data-orientation="horizontal"].theia-app-bottom {
    background: var(--theia-editorGroupHeader-tabsBackground);
}

/* Avoid the Intellisense widget may be cover by the bottom panel partially.
   TODO: This issue may be resolved after monaco-editor upgrade */
#theia-main-content-panel {
    z-index: auto;
}

#theia-main-content-panel div[id^="code-editor-opener"] {
    z-index: auto;
}

.p-TabBar-toolbar .item.arduino-tool-item {
    margin-left: 0;
}

.p-TabBar-toolbar .item.arduino-tool-item .toggle-serial-monitor,
.p-TabBar-toolbar .item.arduino-tool-item .arduino-save-sketch--toolbar,
.p-TabBar-toolbar .item.arduino-tool-item .arduino-open-sketch--toolbar,
.p-TabBar-toolbar .item.arduino-tool-item .arduino-new-sketch--toolbar {
    border-radius: 1px;
}

.p-TabBar-toolbar .item.arduino-tool-item > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--arduino-button-height);
    width: var(--arduino-button-height);
}

.p-TabBar-toolbar .item.arduino-tool-item .arduino-upload-sketch--toolbar,
.p-TabBar-toolbar .item.arduino-tool-item .arduino-verify-sketch--toolbar,
.p-TabBar-toolbar .item.arduino-tool-item .arduino-start-debug {
    background: var(--theia-arduino-toolbar-button-background);
}

.p-TabBar-toolbar .item.arduino-tool-item.enabled:hover > div {
    background: var(--theia-arduino-toolbar-button-hoverBackground);
}

.p-TabBar-toolbar
    .item.arduino-tool-item.enabled:hover
    > div.toggle-serial-monitor,
.p-TabBar-toolbar
    .item.arduino-tool-item.enabled:hover
    > div.toggle-serial-plotter {
    background-color: var(
        --theia-arduino-toolbar-button-secondary-hoverBackground
    );
    border-radius: 14px;
}

.arduino-verify-sketch--toolbar,
.arduino-upload-sketch--toolbar,
.arduino-start-debug {
    border-radius: 14px;
}

.item.arduino-tool-item.toggled {
    background-color: unset;
    opacity: 1;
    border: none;
}

.item.arduino-tool-item.toggled .arduino-verify-sketch--toolbar,
.item.arduino-tool-item.toggled .arduino-upload-sketch--toolbar {
    background-color: var(--theia-arduino-toolbar-toggleBackground) !important;
}

.arduino-tool-icon {
    height: var(--arduino-button-height);
    width: var(--arduino-button-height);
}

.arduino-verify-sketch--toolbar-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
    background-color: var(--theia-titleBar-activeBackground);
}

.arduino-upload-sketch--toolbar-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) center no-repeat;
    background-color: var(--theia-titleBar-activeBackground);
}

.toggle-serial-monitor-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center no-repeat;
    background-color: var(--theia-arduino-toolbar-button-secondary-label);
}

.toggle-serial-plotter-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) center no-repeat;
    background-color: var(--theia-arduino-toolbar-button-secondary-label);
}

.arduino-start-debug-icon {
    -webkit-mask: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 50% 60%;
    -webkit-mask-size: 70%;
    -webkit-mask-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--theia-titleBar-activeBackground);
}

#arduino-toolbar-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.p-TabBar-toolbar.theia-arduino-toolbar {
    align-items: center;
    gap: 8px;
    margin: 0 12px;
    padding: 0;
    z-index: 0;
}

.p-TabBar-toolbar .item > div {
    text-align: center;
}

:root {
    --theia-private-menubar-height: 40px; /* set the topbar height */
}

#theia-top-panel .p-TabBar-toolbar.theia-arduino-toolbar.right {
    justify-content: flex-start;
}

#theia-top-panel .p-TabBar-toolbar.theia-arduino-toolbar.left {
    min-width: 398px;
    justify-content: flex-end;
}

.arduino-toolbar-tooltip {
    display: flex;
    align-items: center;
    color: var(--theia-titleBar-activeForeground);
}

.arduino-open-boards-control-icon {
    mask: none;
    -webkit-mask: none;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--theia-titleBar-activeBackground);
}
.p-TabBar.theia-app-sides .p-TabBar-tabIcon.fa-arduino-folder,
.p-TabBar.theia-app-sides .p-TabBar-tabIcon.fa-arduino-boards {
    font-size: 21px;
}

.monaco-editor .margin {
    border-right: 2px solid var(--theia-sideBar-background);
    box-sizing: border-box;
}

.noWrapInfo {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.theia-sidepanel-toolbar .theia-sidepanel-title {
    margin-left: 10px;
}

/* Output */
.theia-output .editor-container {
    background-color: var(--theia-terminal-background);
}

.theia-output .monaco-editor .lines-content.monaco-editor-background {
    background-color: var(--theia-terminal-background);
}

.theia-output
    .monaco-editor
    .lines-content.monaco-editor-background
    .view-lines
    .view-line
    .mtk1:not(.theia-output-error):not(.theia-output-warning) {
    color: var(--theia-terminal-foreground);
}

.theia-output .monaco-editor .margin {
    border-right: none;
    background-color: var(--theia-terminal-background);
}

.monaco-hover .hover-row.markdown-hover:first-child p {
    margin-top: 8px;
}
.monaco-hover .hover-row.markdown-hover:first-child .monaco-tokenized-source {
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/main.css"],"names":[],"mappings":"AAAA;;IAEI,yDAAyD;AAC7D;;AAEA;iEACiE;AACjE;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;;;IAGI,0DAA0D;AAC9D;;AAEA;IACI,+DAA+D;AACnE;;AAEA;;;;;;IAMI;;KAEC;IACD,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,0EAA0E;AAC9E;;AAEA;IACI,oCAAoC;IACpC,mCAAmC;AACvC;;AAEA;IACI,sEAAuD;IACvD,wDAAwD;AAC5D;;AAEA;IACI,sEAAuD;IACvD,wDAAwD;AAC5D;;AAEA;IACI,sEAAwD;IACxD,qEAAqE;AACzE;;AAEA;IACI,sEAAwD;IACxD,qEAAqE;AACzE;;AAEA;IACI,6DAAoD;IACpD,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oCAAoC,EAAE,0BAA0B;AACpE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6CAA6C;AACjD;AACA;;IAEI,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;;;;;IAMI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB","sourcesContent":["#theia-bottom-content-panel\r\n    .p-TabBar[data-orientation=\"horizontal\"].theia-app-bottom {\r\n    background: var(--theia-editorGroupHeader-tabsBackground);\r\n}\r\n\r\n/* Avoid the Intellisense widget may be cover by the bottom panel partially.\r\n   TODO: This issue may be resolved after monaco-editor upgrade */\r\n#theia-main-content-panel {\r\n    z-index: auto;\r\n}\r\n\r\n#theia-main-content-panel div[id^=\"code-editor-opener\"] {\r\n    z-index: auto;\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-tool-item {\r\n    margin-left: 0;\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-tool-item .toggle-serial-monitor,\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-save-sketch--toolbar,\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-open-sketch--toolbar,\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-new-sketch--toolbar {\r\n    border-radius: 1px;\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-tool-item > div {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: var(--arduino-button-height);\r\n    width: var(--arduino-button-height);\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-upload-sketch--toolbar,\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-verify-sketch--toolbar,\r\n.p-TabBar-toolbar .item.arduino-tool-item .arduino-start-debug {\r\n    background: var(--theia-arduino-toolbar-button-background);\r\n}\r\n\r\n.p-TabBar-toolbar .item.arduino-tool-item.enabled:hover > div {\r\n    background: var(--theia-arduino-toolbar-button-hoverBackground);\r\n}\r\n\r\n.p-TabBar-toolbar\r\n    .item.arduino-tool-item.enabled:hover\r\n    > div.toggle-serial-monitor,\r\n.p-TabBar-toolbar\r\n    .item.arduino-tool-item.enabled:hover\r\n    > div.toggle-serial-plotter {\r\n    background-color: var(\r\n        --theia-arduino-toolbar-button-secondary-hoverBackground\r\n    );\r\n    border-radius: 14px;\r\n}\r\n\r\n.arduino-verify-sketch--toolbar,\r\n.arduino-upload-sketch--toolbar,\r\n.arduino-start-debug {\r\n    border-radius: 14px;\r\n}\r\n\r\n.item.arduino-tool-item.toggled {\r\n    background-color: unset;\r\n    opacity: 1;\r\n    border: none;\r\n}\r\n\r\n.item.arduino-tool-item.toggled .arduino-verify-sketch--toolbar,\r\n.item.arduino-tool-item.toggled .arduino-upload-sketch--toolbar {\r\n    background-color: var(--theia-arduino-toolbar-toggleBackground) !important;\r\n}\r\n\r\n.arduino-tool-icon {\r\n    height: var(--arduino-button-height);\r\n    width: var(--arduino-button-height);\r\n}\r\n\r\n.arduino-verify-sketch--toolbar-icon {\r\n    -webkit-mask: url(../icons/verify.svg) center no-repeat;\r\n    background-color: var(--theia-titleBar-activeBackground);\r\n}\r\n\r\n.arduino-upload-sketch--toolbar-icon {\r\n    -webkit-mask: url(../icons/upload.svg) center no-repeat;\r\n    background-color: var(--theia-titleBar-activeBackground);\r\n}\r\n\r\n.toggle-serial-monitor-icon {\r\n    -webkit-mask: url(../icons/monitor.svg) center no-repeat;\r\n    background-color: var(--theia-arduino-toolbar-button-secondary-label);\r\n}\r\n\r\n.toggle-serial-plotter-icon {\r\n    -webkit-mask: url(../icons/plotter.svg) center no-repeat;\r\n    background-color: var(--theia-arduino-toolbar-button-secondary-label);\r\n}\r\n\r\n.arduino-start-debug-icon {\r\n    -webkit-mask: url(\"../icons/debug-dark.svg\") 50% 60%;\r\n    -webkit-mask-size: 70%;\r\n    -webkit-mask-repeat: no-repeat;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: var(--theia-titleBar-activeBackground);\r\n}\r\n\r\n#arduino-toolbar-container {\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n}\r\n\r\n.p-TabBar-toolbar.theia-arduino-toolbar {\r\n    align-items: center;\r\n    gap: 8px;\r\n    margin: 0 12px;\r\n    padding: 0;\r\n    z-index: 0;\r\n}\r\n\r\n.p-TabBar-toolbar .item > div {\r\n    text-align: center;\r\n}\r\n\r\n:root {\r\n    --theia-private-menubar-height: 40px; /* set the topbar height */\r\n}\r\n\r\n#theia-top-panel .p-TabBar-toolbar.theia-arduino-toolbar.right {\r\n    justify-content: flex-start;\r\n}\r\n\r\n#theia-top-panel .p-TabBar-toolbar.theia-arduino-toolbar.left {\r\n    min-width: 398px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.arduino-toolbar-tooltip {\r\n    display: flex;\r\n    align-items: center;\r\n    color: var(--theia-titleBar-activeForeground);\r\n}\r\n\r\n.arduino-open-boards-control-icon {\r\n    mask: none;\r\n    -webkit-mask: none;\r\n    background: none;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--theia-titleBar-activeBackground);\r\n}\r\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon.fa-arduino-folder,\r\n.p-TabBar.theia-app-sides .p-TabBar-tabIcon.fa-arduino-boards {\r\n    font-size: 21px;\r\n}\r\n\r\n.monaco-editor .margin {\r\n    border-right: 2px solid var(--theia-sideBar-background);\r\n    box-sizing: border-box;\r\n}\r\n\r\n.noWrapInfo {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.theia-sidepanel-toolbar .theia-sidepanel-title {\r\n    margin-left: 10px;\r\n}\r\n\r\n/* Output */\r\n.theia-output .editor-container {\r\n    background-color: var(--theia-terminal-background);\r\n}\r\n\r\n.theia-output .monaco-editor .lines-content.monaco-editor-background {\r\n    background-color: var(--theia-terminal-background);\r\n}\r\n\r\n.theia-output\r\n    .monaco-editor\r\n    .lines-content.monaco-editor-background\r\n    .view-lines\r\n    .view-line\r\n    .mtk1:not(.theia-output-error):not(.theia-output-warning) {\r\n    color: var(--theia-terminal-foreground);\r\n}\r\n\r\n.theia-output .monaco-editor .margin {\r\n    border-right: none;\r\n    background-color: var(--theia-terminal-background);\r\n}\r\n\r\n.monaco-hover .hover-row.markdown-hover:first-child p {\r\n    margin-top: 8px;\r\n}\r\n.monaco-hover .hover-row.markdown-hover:first-child .monaco-tokenized-source {\r\n    margin-top: 8px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
